// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3JM9_","button":"_1gH82","icon":"_2IBSm"};